<template>
  <v-overlay color="white" opacity="1" @click="show = false">
    <div
      style="opacity: 1; visibility: visible; transition: all 2.5s ease"
      :style="page1"
    >
      <v-img
        v-if="mobileLang.code == 'el'"
        src="@/assets/logo.png"
        width="60vw"
        class="mb-16"
      ></v-img>
      <v-img
        v-else
        src="@/assets/logo-en.png"
        width="60vw"
        class="mb-16"
      ></v-img>
    </div>
    <div
      style="opacity: 0; visibility: none; transition: all 2.5s ease"
      :style="page2"
    >
      <div class="top-container">
        <div class="rounded-pill logo-container">
          <img
            v-if="mobileLang.code == 'el'"
            src="@/assets/logo.png"
            class="logo-image"
          />

          <img v-else src="@/assets/logo-en.png" class="logo-image" />
        </div>

        <div class="d-flex flex-column align-center mt-8 pa-4 rounded-lg">
          <div class="welcome-title mb-2 white--text">
            {{ $t("home.welcome") }}
          </div>

          <div class="welcome-subtitle white--text">
            {{ $t("home.subtitle") }}
          </div>
        </div>
      </div>

      <div class="mid-container" v-if="!show">
        <div
          @click="$router.push('/pois')"
          class="button accent mb-2 text-right"
        >
          {{ $t("home.action") }}
        </div>
      </div>
      <!-- <img
          src="@/assets/home_background.png"
          alt="homebg"
          class="background-image"
        /> -->
      <div v-if="!show" class="bg-vid-container">
        <video
          playsinline
          autoplay
          muted
          loop
          id="myVideo"
          v-if="!show"
          class="cover"
        >
          <source
            src="https://www.efales-ar.gr/wp-content/uploads/2022/11/%CF%80%CE%B5%CF%81%CE%B9%CE%AE%CE%B3%CE%B7%CF%83%CE%B7-%CE%B9%CE%B5%CF%81%CE%BF%CF%8D-%CE%9C%CE%AD%CF%83%CF%83%CE%BF%CF%85.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>

    <div
      class="espa-logo"
      style="transition: opacity 3s ease"
      :style="showEspa"
    >
      <img
        v-if="mobileLang.code == 'el'"
        src="@/assets/espa_el.jpg"
        style="width: 250px; height: 35px"
      />
      <img
        v-else
        src="@/assets/espa_en.jpg"
        style="width: 250px; height: 60.5px"
      />
    </div>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    setTimeout(() => (this.show = false), 1000);
  },

  data() {
    return {
      show: true,
      dialog: true,
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
    }),
    wavesAnimation() {
      if (!this.show) {
        console.log;
        return "object-position: 63% 0;";
      } else return "";
    },

    showEspa() {
      if (this.show) {
        return "opacity: 0;";
      } else return "opacity: 1;";
    },

    page1() {
      if (this.show) {
        return "";
      } else return "opacity: 0;visibility: none";
    },

    page2() {
      if (this.show) {
        return "";
      } else return "opacity: 1;visibility: visible;";
    },
  },
};
</script>

<style scoped lang="scss">
.waves-image {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: 30% 0;
  margin-bottom: -80px;
  transition: object-position 2.5s ease;
}

.espa-logo {
  width: 100%;
  height: 105px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
}

.bg-vid-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
}

video.cover {
  width: 100%;
  min-width: 240vh;
  height: auto;
  filter: opacity(60%);
}
.top-container {
  width: 100vw;
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-container {
  width: 200px;
  background-color: #c8d0c9;
  padding: 5px 20px;
}
.logo-image {
  margin-top: 5px;
  width: 100%;
}

.welcome-title {
  width: 250px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.welcome-subtitle {
  font-size: 15px;
  text-align: center;

  font-weight: regular;
  width: 250px;
}

.mid-container {
  position: fixed;
  top: 55%;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
}

.button {
  font-size: 18px;
  border: 2px solid red;
  border-radius: 20px;
  padding: 5px 30px;
  white-space: nowrap;
}

@-webkit-keyframes waves {
  0% {
    object-position: 30% 0;

    // transform: scale(1);
  }

  100% {
    object-position: 63% 0;

    // transform: scale(1);
  }
}
</style>